import { alpha } from "@mui/material/styles";

/**
 * Wrap label + input: light border when empty, brand cyan when the field has a value
 * so users can see what they have already completed.
 */
export function filledFieldWrapSx(theme, filled) {
  return {
    borderRadius: 2,
    px: 1.75,
    py: 1.25,
    border: `1px solid ${
      filled ? theme.palette.brand.cyan : theme.palette.border.light
    }`,
    bgcolor: filled
      ? alpha(theme.palette.brand.cyan, 0.07)
      : alpha(theme.palette.common.black, 0.02),
    transition: "border-color 0.2s ease, background-color 0.2s ease",
  };
}

/**
 * Dashed upload zones: solid cyan border when a file is selected.
 * `emptyDashedColor` should match the previous dashed border (string or theme path resolved by caller).
 */
export function filledUploadDropzoneSx(theme, filled, emptyDashedColor) {
  const dash = emptyDashedColor ?? theme.palette.border.medium;
  return {
    border: filled
      ? `2px solid ${theme.palette.brand.cyan}`
      : `1px dashed ${dash}`,
    bgcolor: filled
      ? alpha(theme.palette.brand.cyan, 0.06)
      : undefined,
    transition: "border-color 0.2s ease, background-color 0.2s ease",
  };
}
